import React from "react";
import ScrollToTop from "../../ScrollToTop";

const PrivacyPolicy = () => {
  return (
    <div className="p-10 section bg-gray-300">
      <ScrollToTop/>
      <div class=" text-gray-900">
    <div class="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg mt-10">
        <h1 class="text-2xl font-bold text-gray-800">Privacy Policy</h1>
        <p class="mt-4 text-gray-600">Effective Date: January 5, 2025</p>
        <h2 class="text-xl font-semibold mt-6">Introduction</h2>
        <p class="mt-4 text-gray-600">The portal, <a href="https://pronttera.com" class="text-blue-600">https://pronttera.com</a> and all its subdomains (the “Website”), is owned and operated by Pronttera (“Company”, “us”, “we”, “our”).</p>
        <p class="mt-4 text-gray-600">This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you visit our Website and use our services, including tailored software solutions, collaboration opportunities, and consultation services (the “Services”).</p>
        <h2 class="text-xl font-semibold mt-6">Information Collection</h2>
        <ul class="list-disc list-inside mt-4 text-gray-600">
            <li><strong>Personal Information:</strong> Name, email address, phone number, company details, and communication details.</li>
            <li><strong>Sensitive Personal Information:</strong> Payment details and information voluntarily shared during consultation sessions.</li>
            <li><strong>Automatically Collected Information:</strong> Browser type, IP address, and browsing activity.</li>
            <li><strong>Third-Party Information:</strong> Data from social media integrations.</li>
        </ul>
        <h2 class="text-xl font-semibold mt-6">Use of Information</h2>
        <p class="mt-4 text-gray-600">We collect and process information for service improvement, communication, security, and compliance with legal obligations.</p>
        <h2 class="text-xl font-semibold mt-6">Cookies</h2>
        <p class="mt-4 text-gray-600">We use cookies to authenticate login information, analyze site performance, and provide targeted advertisements.</p>
        <h2 class="text-xl font-semibold mt-6">Sharing of Information</h2>
        <p class="mt-4 text-gray-600">Your information may be shared with affiliates, government authorities, and during business transfers but will never be sold.</p>
        <h2 class="text-xl font-semibold mt-6">Security</h2>
        <p class="mt-4 text-gray-600">We employ administrative, technical, and physical safeguards to protect your personal information.</p>
        <h2 class="text-xl font-semibold mt-6">Your Rights</h2>
        <p class="mt-4 text-gray-600">You may access, update, or withdraw consent regarding your personal information.</p>
        <h2 class="text-xl font-semibold mt-6">Retention of Information</h2>
        <p class="mt-4 text-gray-600">Your information is retained as long as necessary for our services unless deletion is requested.</p>
        <h2 class="text-xl font-semibold mt-6">Links to Third-Party Websites</h2>
        <p class="mt-4 text-gray-600">We are not responsible for the privacy policies of third-party websites linked on our Website.</p>
        <h2 class="text-xl font-semibold mt-6">Privacy of Minors</h2>
        <p class="mt-4 text-gray-600">Our Website is not intended for individuals under 18, and we delete collected minor data promptly.</p>
        <h2 class="text-xl font-semibold mt-6">Changes to the Privacy Policy</h2>
        <p class="mt-4 text-gray-600">Updates to this policy will be posted on this page with the effective date.</p>
        <h2 class="text-xl font-semibold mt-6">Contact Us</h2>
        <p class="mt-4 text-gray-600">Email: contact@pronttera.com</p>
        <p class="mt-4 text-gray-600">Phone: +91 9834174885</p>
        <p class="mt-4 text-gray-600">Address: Shah Building, First Floor, Kalas, Alandi Road, Pune</p>
        <h2 class="text-xl font-semibold mt-6">Grievance Officer</h2>
        <p class="mt-4 text-gray-600">Name: Adeeb Shah</p>
        <p class="mt-4 text-gray-600">Designation: Grievance Officer</p>
        <p class="mt-4 text-gray-600">Email: info@pronttera.com</p>
        <p class="mt-4 text-gray-600">Phone: +91 9834174885</p>
        <p class="mt-6 text-gray-600 font-semibold">By using our Website or Services, you confirm that you have read and understood this Privacy Policy and agree to its terms.</p>
    </div>
    </div>
      {/* Add more privacy-related content as needed */}
    </div>
  );
};

export default PrivacyPolicy;
